import { useState } from "react";
import { X, Layers } from "lucide-react";
import DatePicker from "@/components/DatePicker";

const FIELDS = [
  { key: "musteri", label: "Müşteri", type: "text" },
  { key: "aciklama", label: "Açıklama", type: "text" },
  { key: "tarih", label: "İşlem Tarihi", type: "date" },
  { key: "vade_tarihi", label: "Vade Tarihi", type: "date" },
  { key: "alis_fiyati", label: "Alış Fiyatı", type: "number" },
  { key: "satis_fiyati", label: "Satış Fiyatı", type: "number" },
  { key: "icra_tutari", label: "İcra Tutarı", type: "number" },
  { key: "tahsilat", label: "Tahsilat", type: "number" },
  { key: "odenen", label: "Ödenen", type: "number" },
  { key: "asil_alacak", label: "Asıl Alacak", type: "number" },
];

export default function BulkEditDialog({ count, onClose, onApply }) {
  const [field, setField] = useState("icra_tutari");
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);
  const meta = FIELDS.find((f) => f.key === field);

  const submit = async () => {
    let v = value;
    if (meta.type === "number") v = Number(value) || 0;
    if (meta.type === "date") v = value || null;
    setSaving(true);
    try {
      await onApply(field, v);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center bg-black/40 p-4 overflow-y-auto">
      <div className="bg-white border border-[#E7DECC] rounded-sm w-full max-w-md my-16" data-testid="bulk-edit-dialog">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E7DECC]">
          <div className="flex items-center gap-2">
            <Layers className="w-5 h-5 text-[#B8933F]" />
            <h3 className="font-heading text-xl font-bold tracking-tight">Toplu Düzenle</h3>
          </div>
          <button onClick={onClose} aria-label="Kapat" data-testid="bulk-edit-close" className="text-[#8C8377] hover:text-[#26231E]">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-sm text-[#8C8377] mb-5">
            Seçili <span className="font-semibold text-[#26231E]">{count}</span> kaydın belirtilen alanı aynı değerle güncellenecek.
          </p>

          <label className="kicker block mb-1.5">GÜNCELLENECEK ALAN</label>
          <select
            value={field}
            onChange={(e) => {
              setField(e.target.value);
              setValue("");
            }}
            data-testid="bulk-edit-field-select"
            className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm bg-white mb-4 focus:outline-none focus:border-[#B8933F]"
          >
            {FIELDS.map((f) => (
              <option key={f.key} value={f.key}>
                {f.label}
              </option>
            ))}
          </select>

          <label className="kicker block mb-1.5">YENİ DEĞER</label>
          {meta.type === "date" ? (
            <DatePicker value={value} onChange={setValue} placeholder="Tarih seçin" testId="bulk-edit-date-input" />
          ) : (
            <input
              type={meta.type === "number" ? "number" : "text"}
              step="0.01"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              data-testid="bulk-edit-value-input"
              className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm focus:outline-none focus:border-[#B8933F]"
              placeholder={meta.type === "number" ? "0" : "Değer girin"}
            />
          )}

          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={onClose}
              data-testid="bulk-edit-cancel"
              className="px-4 py-2 border border-[#E7DECC] rounded-sm text-sm font-medium hover:bg-[#EFE7D6] transition-colors duration-150"
            >
              İptal
            </button>
            <button
              onClick={submit}
              disabled={saving}
              data-testid="bulk-edit-apply"
              className="px-6 py-2 bg-[#B8933F] hover:bg-[#9C7A33] text-white rounded-sm text-sm font-medium transition-colors duration-150 disabled:opacity-60"
            >
              {saving ? "Uygulanıyor..." : "Uygula"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
